
<section class="{{ class }}">
  <lib-container>
    <div class="py-6">
      <h2 class="mt-5 mb-4">
        Bestellung
        <span class="text-header-underlined">smarthandwerk pro</span>
      </h2>
      <p class="white-space-nowrap {{ class + '__sub-header' }}">
        Erfahren Sie mehr unter
        <a href="https://smarthandwerk.de/pro/" class="text-underlined" target="_blank">smarthandwerk.de</a>
      </p>
    </div>
    
    <div class="{{ class + '__content' }}">
      <div class="{{ class + '__left' }}">
        <ng-container *ngIf="isInitialized; else loading">
          <lib-new-plan-selector
            [company]="frontPageTxt.newCustomer['header'].company"
            [tag]="frontPageTxt.planUpgrade['header'].tag"
            [plan]="(plan$ | async)!"
            [disclaimer]="
              frontPageTxt.planUpgrade['disclaimer']
            "
            [isSubscriptionPlans]="false"
            [customer]="(customer$ | async)!"
          ></lib-new-plan-selector>
        </ng-container>
      </div>
      <div class="{{ class + '__right' }}">
        <lib-module-addons [isNewCustomerPlan]="true"></lib-module-addons>
      </div>
    </div> 

    <ng-template #loading>
      <h4>
        Bitte warten...
        <i class="pi pi-spin pi-spinner"></i>
      </h4>
    </ng-template>
  </lib-container>
</section>
